<template>
  <div class="rt-rooms-table">
    <el-table
      :data="props.users"
      style="width: 100%"
      size="small"
      border
      empty-text="No data"
      highlight-current-row
      :cell-class-name="cellGrayRoom"
      class="rt-table"
    >
      <el-table-column
        prop="guestName"
        label="Room"
        align="left"
        min-width="120"
        show-overflow-tooltip
      />
      <el-table-column
        label="CreateTime"
        align="center"
        width="110"
      >
        <template #default="scope">
          <span
            v-formatter="{
              data: scope.row.createTime,
              formatter: 'HH:mm:ss',
              type: 'date',
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="agentNickNameList"
        label="Agent"
        align="left"
        min-width="140"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span v-if="(scope.row.agentNickNameList || []).length < 1">-</span>
          <span v-else>
            {{ (scope.row.agentNickNameList || []).join() }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Status"
        align="center"
        width="110"
      >
        <template #default="scope">
          <el-tag
            :type="roomTagType(scope.row.status)"
            size="small"
            effect="light"
          >
            {{ scope.row.status || '-' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="country"
        label="Country"
        align="center"
        min-width="100"
      />
      <el-table-column
        prop="province"
        label="Province"
        align="center"
        min-width="100"
      />
      <el-table-column
        prop="guestIp"
        label="IP"
        align="left"
        min-width="120"
      >
        <template #default="scope">
          <span class="num-cell">{{ scope.row.guestIp }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { cellGrayRoom } from '@/utils/style'

const props = defineProps({
  users: {
    type: Array,
    default: () => {
      return [];
    },
  },
})

function roomTagType(s) {
  if (s === 'FINISHED' || s === 'CLOSED') return 'danger'
  if (s === 'MATCHED' || s === 'ROBOT') return 'success'
  return 'warning'
}
</script>

<style scoped>
.rt-rooms-table {
  width: 100%;
}
.rt-table :deep(thead th) {
  background: #f5f7fa;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
}
.num-cell {
  font-variant-numeric: tabular-nums;
}
</style>
